export class 外部連携取込日付設定有無型 {
    日付設定有無: boolean;
    constructor() {
        this.日付設定有無 = true;
    }
}
